import { SharedProps } from '@/types'
import { usePage } from '@inertiajs/react'
import { useState } from 'react'
import { toast } from 'react-hot-toast'

// Shared print flow: browser print when CloudPRNT is disabled, or a direct send to a chosen
// printer when it is enabled. The caller renders one button per printer and dispatches here.
export function usePrintDispatch({ send }: { send: (printerId: number | null) => Promise<unknown> }) {
  const { current_organization } = usePage<SharedProps>().props
  const cloudprntEnabled = current_organization?.cloudprnt_enabled ?? false
  const [printingPrinterId, setPrintingPrinterId] = useState<number | null | undefined>(undefined)

  const printBrowser = () => window.print()

  const printToPrinter = async (printerId: number | null) => {
    setPrintingPrinterId(printerId)
    try {
      await send(printerId)
      toast.success("Tickets envoyés à l'imprimante.")
    } catch {
      if (confirm("Échec de l'envoi à l'imprimante. Imprimer via le navigateur ?")) window.print()
    } finally {
      setPrintingPrinterId(undefined)
    }
  }

  return { cloudprntEnabled, printingPrinterId, printBrowser, printToPrinter }
}
